import request from './request';

export const analysis = {
  pageview(params = {}) {
    return request.get(`analysis/pageview`, { params });
  },
}
